import { useFullDomainUrl } from '@/hooks/use-full-domain-url'
import { gaViewItem } from '@/utils/gtag'
import { useEffect, useRef } from 'react'
import { useQuery } from '@tanstack/react-query'
import { queries } from '@/shared/lib/tanstack-query/query-keys'
import { useCurrentUser } from '@/hooks/use-current-user'

interface UseGaViewEventProps {
  productId: string
}

export function useProductDetailGA({ productId }: UseGaViewEventProps) {
  const domainUrl = useFullDomainUrl()
  const { user } = useCurrentUser()
  const hasSentEventRef = useRef(false)

  const { data: product } = useQuery(queries.products.detail(productId))

  useEffect(() => {
    if (process.env.NODE_ENV === 'test') {
      return
    }
    if (!product) return
    if (hasSentEventRef.current) return
    hasSentEventRef.current = true

    gaViewItem({
      item: {
        id: product.id,
        title: product.title,
        price: product.price.price,
        categoryName: product.subCategory?.name,
      },
      pageUrl: domainUrl,
      userId: user.id || null,
    })
  }, [product, domainUrl, user.id])
}
